module.exports = __webpack_public_path__ + "static/media/Quote_love_how_you_feel_dance_fitness.7da6e30c.webp";